import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  min-height: 100vh;
  background: #ebebeb;
  padding: 20px;
`;

export const LoginBox = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
  padding: 40px 32px 32px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

  & > img {
    height: 48px;
    object-fit: contain;
    margin-bottom: 32px;
    align-self: center;
  }
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-bottom: 6px;
  font-family: 'Montserrat', sans-serif;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-bottom: 16px;
  background: #fff;
  color: #333;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3483fa;
    box-shadow: 0 0 0 1px #3483fa33;
  }

  &::placeholder {
    color: #aaa;
  }
`;

export const LoginButton = styled.button`
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #fff;
  background: #3483fa;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;

  &:hover {
    background: #2968c8;
  }

  &:active {
    background: #1f54a0;
  }
`;

export const ForgotLink = styled.span`
  font-size: 14px;
  color: #3483fa;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    text-decoration: underline;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #eee;
  margin: 20px 0 0;
`;
